// Contract addresses - Updated with actual deployed addresses
export const CONTRACT_ADDRESSES = {
  TESTNET: '0xAfd8825Be638c8008004A71Fffe052F659458c55', // SevenUniverse testnet contract
  MAINNET: '0x1F3896524dbD810Aa2ab096E8e585c7DcFa5e11B'  // Add mainnet address when deployed
};

// USDT addresses on OpBNB
export const USDT_ADDRESSES = {
  TESTNET: '0xBf6596a279172D330b8b732D257Ee633B6FDA911', // USDT testnet address
  MAINNET: '0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3'  // OpBNB mainnet USDT
};

// Package prices in USDT
export const PACKAGE_PRICES = {
  U1: '10',
  U2: '20', 
  U3: '40',
  U4: '80',
  U5: '150',
  U6: '250',
  U7: '450'
};

// Package names
export const PACKAGE_NAMES = [
  'U1 - Genesis',
  'U2 - Nebula', 
  'U3 - Solar',
  'U4 - Galactic',
  'U5 - Stellar',
  'U6 - Cosmic',
  'U7 - Universal'
];

// Pool names
export const POOL_NAMES = {
  1: 'Galaxy Pool',
  2: 'Cosmos Pool',
  3: 'Universe Pool',
  4: 'Eternal Pool'
};

// Admin/Owner wallet addresses - Update these with actual admin addresses
export const ADMIN_ADDRESSES = [
  '0xe4FcC7d3d7ce9c364b6e4b0b62C321e81B270454', // Admin address
  '0xFE388e83D35eda4B3f93cD4393F92a02f808082F'  // Owner address
];

// Activity types
export const ACTIVITY_TYPES = {
  0: 'Registration',
  1: 'Package Upgrade',
  2: 'Sponsor Income',
  3: 'Level Income',
  4: 'Pool Income',
  5: 'Income Claimed',
  6: 'Package Retopup'
};

// Network configurations
export const NETWORK_CONFIGS = {
  OPBNB_TESTNET: {
    chainId: '0x15EB',
    chainName: 'opBNB Testnet',
    rpcUrls: ['https://opbnb-testnet-rpc.bnbchain.org'],
    blockExplorerUrls: ['https://testnet.opbnbscan.com'],
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    }
  },
  OPBNB_MAINNET: {
    chainId: '0xCC',
    chainName: 'opBNB Mainnet', 
    rpcUrls: ['https://opbnb-mainnet-rpc.bnbchain.org'],
    blockExplorerUrls: ['https://opbnbscan.com'],
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    }
  }
};

// Utility functions
export const formatAddress = (address) => {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

export const formatNumber = (num) => {
  if (!num) return '0';
  const number = parseFloat(num);
  if (number < 0.001 && number > 0) {
    return '<0.001';
  }
  return number.toLocaleString(undefined, { 
    minimumFractionDigits: 0,
    maximumFractionDigits: 3 
  });
};

export const formatUSDT = (amount) => {
  return `${formatNumber(amount)} USDT`;
};

export const generateReferralLink = (userId) => {
  return `${window.location.origin}?ref=${userId}`;
};

export const getReferralIdFromURL = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('ref');
};